<div class="modal-container">
    <div class="modal-exit">
        <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
    </div>
    <div class="d-flex d-row">
        <div class="modal-title-subtitle">
            <div class="modal-title">
                <span>
                    {{ 'want_delete_file' | translate }}</span>
            </div>
        </div>
    </div>
    <div class="section-title">{{ 'want_delete_file_description' | translate }}</div>
    <div class="d-flex align-items-end justify-content-end tyre-options-container w-100 gap-2">
        <div class="back-button">
            <a (click)="close()" (keyup)="close()" tabindex="0" type="submit">
                {{ 'keep_file' | translate }}
            </a>
        </div>
        <div class="delete-button">
            <a (click)="delete()" (keyup)="delete()" tabindex="0" type="submit">
                {{ 'delete' | translate }}
            </a>
        </div>
    </div>

</div>